// removed by extract-text-webpack-plugin
module.exports = {"picker":"_3UuF5ljUtRTUJZHG","itemContainer":"_3-rn4S2EMIFNrXT5","hoverLabel":"_31EQBk5YuFE66vPa","content":"_5RA5xsxNE-Z0ZVts"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Common/ColorPicker.pcss
// module id = 469
// module chunks = 1